import { Box, Skeleton } from "@mui/material";
import React from "react";

const StockCardSkeleton = () => {
  return (
    <Box
      sx={{
        width: "26.25vw",
        height: "11.6vw",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "0.5vw",
        backgroundColor: "#191818",
        borderRadius: "0.5vw",
        border: "1px solid #C0C0C0",
      }}
    >
      {/* Left Section */}
      <Box
        sx={{
          flex: 0.6,
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          height: "100%",
        }}
      >
        {/* Left Column Details */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            gap: "0.5vw"
          }}
        >
          {Array.from({ length: 6 }).map((_, index) => (
            <Box
              key={index}
              sx={{ display: "flex", alignItems: "center", gap: "0.5vw" }}
            >
              <Skeleton variant="circular" width="1.2vw" height="1.2vw" />
              <Skeleton variant="text" width="10vw" height="1vw" />
            </Box>
          ))}
        </Box>

        {/* Middle Column Icons */}
        <Box sx={{ position: "relative", mr: "0.55vw" }}>
          {Array.from({ length: 3 }).map((_, index) => (
            <Box
              key={index}
              sx={{
                position: index === 2 ? "absolute" : "static",
                bottom: index === 2 ? 0 : "auto",
                mt: index !== 2 ? "0.3vw" : 0,
              }}
            >
              <Skeleton variant="circular" width="1.6vw" height="1.6vw" />
            </Box>
          ))}
        </Box>
      </Box>

      {/* Right Image Section */}
      <Box
        sx={{
          flex: 0.4,
          width: "10.6vw",
          height: "10.6vw",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#2b2b2b",
        }}
      >
        <Skeleton variant="rectangular" width="100%" height="100%" />
      </Box>
    </Box>
  );
};

export default StockCardSkeleton;
